<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2020-04-24 17:09:42
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2021-05-08 18:01:31
 * @Description: 
 * @FilePath: /src/components/customerService/btn.vue
--> 
<style lang="less" scoped>
    @import url('~@/lib/base.less');
    .custimer-service-btn {
        margin-top: .pxToRem(30) [];
        .sq(96);
        background: white;
        border-radius: 100%;
        box-shadow: .pxToRem(3) [] .pxToRem(8) [] .pxToRem(15) [] 0 rgba(0, 0, 0, 0.15);
        .cs-img {
            .base-center-x;
            top: .pxToRem(16) [];
            .sq(40);
            pointer-events: all;
        }
        .text {
            .base-center-x;
            bottom: .pxToRem(10) [];
            font-size: .pxToRem(20) [];
            color: rgba(0, 0, 0, 0.9);
            height: .pxToRem(28) [];
            line-height: .pxToRem(28) [];
        }
    }
</style>

<template>
    <div class="components custimer-service-btn">
        <img class="cs-img"
             @click="toCs"
             :src="require('@/assets/icons/icon-customer-service.png')">
        <div class="text">客服</div>
    </div>
</template>
<script>
    import { PAGE_CUSTOMER_SERVICE } from 'page';
    export default {
        methods: {
            toCs() {
                if (this.$store.state.user.token) {
                    this.$util.pageJump(PAGE_CUSTOMER_SERVICE)
                    // this.$customerService.open();
                }
                else {
                    this.$loginModel.open();
                }
            }
        }
    }
</script>
